import lazyGettext from 'js-utils/lazy-gettext';
import gettext from 'js-utils/gettext';
import { AU_LOCALE, GB_LOCALE, IE_LOCALE } from 'js-utils/intl';

export const SCRIPT_CRAZY_EGG =
    'https://script.crazyegg.com/pages/scripts/0047/7928.js';

export const PACKAGE_ONE_NAME = lazyGettext('Essentials');
export const PACKAGE_TWO_NAME = lazyGettext('Professional');
export const PACKAGE_TWO_ADDON_NAME = lazyGettext('Professional Plus');
export const PACKAGE_THREE_NAME = 'Premium';
export const PACKAGE_ONE_DESCRIPTION = lazyGettext(
    'The essentials you need to start selling in minutes.',
);
export const PACKAGE_TWO_DESCRIPTION = lazyGettext(
    'A powerful solution to boost sales and grow your business.',
);
export const PACKAGE_TWO_ADDON_DESCRIPTION = lazyGettext(
    'A subscription designed for power users who host many events.',
);
export const PACKAGE_THREE_DESCRIPTION = lazyGettext(
    'Tailored partnership for organizers with large and complex events',
);
export const DEFAULT_PACKAGES = [
    PACKAGE_ONE_NAME,
    PACKAGE_TWO_NAME,
    PACKAGE_THREE_NAME,
];

// Page names used for locale overrides constants
export const OVERVIEW_PAGE = 'overview';
export const PACKAGE_COMPARISON_PAGE = 'packageComparison';
export const PACKAGE_ONE_PAGE = 'packageOne';
export const PACKAGE_TWO_PAGE = 'packageTwo';
export const PACKAGE_THREE_PAGE = 'packageThree';
export const PACKAGE_SELECTION_PAGE = 'packageSelection';
export const PRICING_PAGE = 'pricing';
export const SIGNUP_PAGE = 'signup';

// PART OF SMOKESCREEN EXPERIMENT
export const BEYOND_FREE_C_PACKAGES = [
    PACKAGE_ONE_NAME,
    PACKAGE_TWO_NAME,
    PACKAGE_TWO_ADDON_NAME,
];
export const BEYOND_FREE_D_PACKAGES = [
    PACKAGE_ONE_NAME,
    PACKAGE_TWO_NAME,
    PACKAGE_TWO_ADDON_NAME,
    PACKAGE_THREE_NAME,
];

export const PACKAGE_DESCRIPTIONS = [
    PACKAGE_ONE_DESCRIPTION,
    PACKAGE_TWO_DESCRIPTION,
    PACKAGE_THREE_DESCRIPTION,
];
export const PACKAGE_ADDON_DESCRIPTIONS = [
    PACKAGE_ONE_DESCRIPTION,
    PACKAGE_TWO_DESCRIPTION,
    PACKAGE_TWO_ADDON_DESCRIPTION,
];
export const PACKAGE_ONE = 'package1';
export const PACKAGE_ONE_VERSION_1 = 'package1v1';
export const PACKAGE_ONE_VERSION_2 = 'package1v2';
export const PACKAGE_TWO = 'package2';
export const PACKAGE_TWO_ADDON = 'package2addon';
export const PACKAGE_THREE = 'package3';
export const LEGACY = 'legacy';
export const DEFAULT_PACKAGE_TYPES = [PACKAGE_ONE, PACKAGE_TWO, PACKAGE_THREE];
export const PACKAGE_TYPES_WITHOUT_PREMIUM = [
    PACKAGE_ONE,
    PACKAGE_TWO,
    PACKAGE_TWO_ADDON,
];
export const PACKAGE_VERSION_1 = 1;
export const PACKAGE_VERSION_2 = 2;

const PACKAGE_ONE_CTA_TEXT = lazyGettext('Try Essentials');
const PACKAGE_TWO_CTA_TEXT = lazyGettext('Try Professional');

export const UPDATE_TEXT = lazyGettext('Update');
export const UPGRADE_TEXT = lazyGettext('Upgrade');
export const CONTACT_US_TEXT = lazyGettext('Contact Us');
export const GET_STARTED_TEXT = lazyGettext('Get Started');
export const SIGNUP_CTAS = [
    PACKAGE_ONE_CTA_TEXT,
    PACKAGE_TWO_CTA_TEXT,
    CONTACT_US_TEXT,
];

export const CUSTOM_PRICING = lazyGettext('Custom Pricing');
export const INCLUDED_TEXT = lazyGettext('Included');
export const FINE_PRINT_WITH_FIXED_FEE = lazyGettext(
    '* Payment processing and taxes will apply to all packages.',
);
// extra space at the end of sentence is intentional because string gets translated to
// fine print without fixed fee string for Australian languages in transifex.
export const FINE_PRINT_WITH_FIXED_FEE_NZ = lazyGettext(
    '* Payment processing and taxes will apply to all packages. ',
);
export const FINE_PRINT_WITHOUT_FIXED_FEE = lazyGettext(
    '* Taxes will apply to all packages.',
);
export const PER_PAID_TICKET_TEXT = lazyGettext('/ paid ticket*');
export const PER_PAID_TICKET_WITHOUT_FINE_PRINT = lazyGettext(
    ' / per paid ticket',
);
export const PRICE_PER_PAID_TICKET = lazyGettext('Fee per paid ticket');
export const PACKAGE_ONE_PRESELECTED_CTA_TEXT = lazyGettext(
    'Continue with Essentials',
);
export const PACKAGE_TWO_PRESELECTED_CTA_TEXT = lazyGettext(
    'Continue with Professional',
);
export const PACKAGE_THREE_PRESELECTED_CTA_TEXT = lazyGettext(
    'Contact us with Premium',
);
export const ANNUAL_FEE_TITLE = lazyGettext('Annual Fee');

// EXPERIMENT_MARKER=LOW_ATV_CAPPED_FEE
export const getCappedFeeTitleOverThreshold = (threshold) =>
    gettext('Fee per paid ticket over %(threshold)s', { threshold });

export const getCappedFeeTitleUnderThreshold = (threshold) =>
    gettext('Fee per paid ticket %(threshold)s and under', { threshold });

// ************* PATHS ************* //
export const BASE_URL = '/organizer/';
export const OVERVIEW_PATH = 'overview';
export const PRICING_PATH = 'pricing';
export const PACKAGE_COMPARISON_PATH = 'compare-packages';
export const PACKAGE_ONE_PATH = 'essentials';
export const PACKAGE_TWO_PATH = 'professional';
export const PACKAGE_THREE_PATH = 'premium';
export const PACKAGE_PATHS = [
    `${BASE_URL + PACKAGE_ONE_PATH}`,
    `${BASE_URL + PACKAGE_ONE_PATH}`,
    `${BASE_URL + PACKAGE_ONE_PATH}`,
];
export const SIGNIN_URL = '/login/?referrer=/create';
export const CONTACT_SALES_URL = '/contact-sales';
export const CONTACT_US_PATH = '/support/contact-us';

export const CHANGE_PLAN_PATH = 'change-plan';
export const CHANGE_PLAN_DOWNGRADE_PATH = 'change-plan/downgrade';
export const CHANGE_PLAN_DOWNGRADE_CONFLICTS_PATH = 'conflicts';
export const CHANGE_PLAN_UPDATE_PATH = 'change-plan/update';
export const CHANGE_PLAN_SALES_PATH = 'change-plan/sales';
export const CHANGE_PLAN_NON_ADMIN_PATH = 'change-plan/access';
export const ACCOUNT_SETTINGS_URL = '/myaccount/plan';
export const ACCOUNT_URL = '/account';
export const ACCOUNT_SETTINGS_URL_V2 = '/account-settings/plan/';
export const ESSENTIAL_V2_UPDATE_URL = '/organizer/change-plan/update';

export const ACCOUNT_SETTINGS_UPGRADE_SUCCESS_PATH =
    '/myaccount/plan/?success=upgrade';
export const ACCOUNT_SETTINGS_DOWNGRADE_SUCCESS_PATH =
    '/myaccount/plan/?success=downgrade';
export const ACCOUNT_SETTINGS_CANCEL_SUCCESS_PATH =
    '/myaccount/plan/?success=cancel';
export const ACCOUNT_SETTINGS_UPGRADE_FAIL_PATH =
    '/myaccount/plan/?failure=upgrade';
export const ACCOUNT_SETTINGS_DOWNGRADE_FAIL_PATH =
    '/myaccount/plan/?failure=downgrade';
export const ACCOUNT_SETTINGS_CANCEL_FAILURE_PATH =
    '/myaccount/plan/?failure=cancel';

export const ONBOARDING_PATH = 'onboarding';
export const PACKAGE_SELECTION_PATH = 'packages';
export const SIGNUP_PATH = 'signup';
export const SIGNIN_PATH = '/signin';
export const CREATE_PATH = '/create';
export const PACKAGE_ONE_CREATE_PATH = `/create?success=1&pckg=${PACKAGE_ONE_NAME}`;
export const PACKAGE_TWO_CREATE_PATH = `/create?success=1&pckg=${PACKAGE_TWO_NAME}`;
export const PACKAGE_TWO_ADDON_CREATE_PATH = `/create?success=1&pckg=${PACKAGE_TWO_ADDON_NAME}`;
export const COPY_PATH = `/copy?success=1&pckg=${PACKAGE_TWO_NAME}`;
export const SCROLLABLE_PATHS = [OVERVIEW_PATH];

export const USER_PREBUYER = 6;
export const USER_EVENT_ATTENDEE = 2;

export const NEW_TAG_TEXT = lazyGettext('New');
export const FEATURE_UNLIMITED_TICKET_TYPES = 'Unlimited ticket types';

// Janus Constants
export const VARIANT_A = 'A';
export const VARIANT_B = 'B';
export const VARIANT_C = 'C';
export const VARIANT_D = 'D';

export const HIGHLIGHT_TEXT_B = lazyGettext('Recommended');
export const HIGHLIGHT_TEXT_C = lazyGettext('Best Value');
export const HIGHLIGHT_TEXT_D = lazyGettext('Most Popular');

// Experiments
export const SHOW_LOW_ATV_UI = 'showLowAtvUi';

// Switch order of pricing presentation in UK and IE
// https://jira.evbhome.com/browse/EB-88197
export const LOCALES_WITH_FEES_SWITCHED = {
    [GB_LOCALE]: true,
    [IE_LOCALE]: true,
};

export const LOCALES_WITH_TAX_LABEL = {
    [GB_LOCALE]: {
        taxName: 'UK VAT',
    },
};

export const LOCALE_WITH_VERSION_2 = [AU_LOCALE];
